export default "__VITE_ASSET__BUrstegm__"